var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$slots['default'])?_c('nav',{staticClass:"iconNav"},[_c('ul',{staticClass:"iconNav__list"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }